import * as Yup from "yup";

const stockAdjustmentSchema = {};

stockAdjustmentSchema.validateAdd = (values) => {
  let schema = Yup.object({
    branch_id: Yup.string().required("Branch Name is Required."),
    stk_adj_type: Yup.string().required("stk adj type is Required."),
    stk_adj_date: Yup.string().required("Date is Required."),
    narration: Yup.string()
      // .matches(/^[a-zA-Z0-9 ]*$/, "Narration must be a alphanumeric character")
      .required("Narration is Required"),
    item_dtl: Yup.array()
      .of(
        Yup.object({
          item_id: Yup.string().required("Item Name is Required"),
          qty: Yup.string()
            .required("Item Qty is Required")
            .min(1, "Invalid Item Details."),
          rate: Yup.string().required("Item Price is Required"),
          godown_id: Yup.string()
            .typeError("Godown is Required")
            .required("Godown is Required"),
        })
      )
      .min(1, "Invalid Item Details."),
  });

  return schema.validate(values, { abortEarly: false }).catch((err) => err);
};

stockAdjustmentSchema.validateEdit = (values) => {
  let schema = Yup.object({
    branch_id: Yup.string().required("Branch Name is Required."),
    stk_adj_type: Yup.string().required("Stock Adjustment type is Required."),
    item_dtl: Yup.array()
      .of(
        Yup.object({
          item_id: Yup.string().required("Item Name is Required"),
          qty: Yup.string().required("Item Qty is Required"),
          rate: Yup.string().required("Item Price is Required"),
        })
      )
      .min(1, "Invalid Item Details."),
  });

  return schema.validate(values, { abortEarly: false }).catch((err) => err);
};

export default stockAdjustmentSchema;
